import { Component, OnInit,ViewChild } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-website-detail',
  templateUrl: './website-detail.component.html',
  styleUrls: ['./website-detail.component.css']
})
export class WebsiteDetailComponent implements OnInit {
  registerForm: FormGroup;
  submitted = false;
  constructor(private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute) {
    this.registerForm = this.fb.group({
      webisteUrl: ['', Validators.required],
      emailId: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]]
  });
   }
   get f() { return this.registerForm.controls; }
  ngOnInit(): void {
  }
  onSubmit() {
    // this.submitted = true;

    // // // stop here if form is invalid
    // // if (this.registerForm.invalid) {
    // //     return;
    
    // // display form values on success
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value, null, 4));
}
onReset() {
   // this.submitted = false;
   // this.registerForm.reset();
  // this.router.navigateByUrl('/');
}

}
